<template>
  <div class="box">
    <arrorImg bg="white"></arrorImg>
    <navBar title="阅读小管家" color="#ffffff"></navBar>
    <div class="content">
      <img src="../../../static/activity-bg.jpg" alt="" />
      <div class="content-pos">
        <p class="content-title">成功添加微信即可获得</p>
        <p class='line'></p>
        <p class="content-tips">200书币+永久VIP服务</p>
        <div class='content-code'>
          <img src="../../../static/code.jpg" alt="">
        </div>
        <p class='text-one'>添加微信阅读小管家</p>
        <p class='text-two'>（长按图片，识别二维码添加微信好友）</p>
        <p class='text-three'>小管家在这里期待与您相见！</p>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, MessageBox } from "mint-ui";
import arrorImg from "../../components/arrow-img.vue";
import navBar from "../components/navbar.vue";
export default {
  components: {
    arrorImg,
    navBar,
  },
  data() {
    return {
      isEntranceData: "",
      pageType:''
    };
  },
  mounted() {
    if (this.$route.query.isEntranceData) {
      this.isEntranceData = this.$route.query.isEntranceData;
    }
    if(this.$route.query.pageType){
      this.pageType = this.$route.query.pageType;
    }
    var openid = this.$base.getStorage("openid");
    var isWxAuthorized = this.$base.getStorage("isWxAuthorized");
    var city = this.$base.getStorage("city");
    if (!openid) {
    } else if (
      isWxAuthorized == 0 &&
      city == 1 &&
      openid &&
      !this.$store.state.user.isSNS
    ) {
      this.$base.setStorage("isSNS", true);
      this.$store.state.user.isSNS = true;
      this.$commonApi.snsapiUserinfo();
      this.insertPageAccessData();
   
    } else {
      this.insertPageAccessData();
    }
  },
  methods: {
    insertPageAccessData() {
      var prevPage = "";
      if (this.pageType === "bookCurrency") {
        prevPage = "书币";
      }else if (this.pageType === "bookCharge") {
        prevPage = "充值中心";
      } else if (this.pageType === "bookCity") {
        prevPage = "书城";
      } 
      var params = {
        pageName: "微信导粉页",
        pageRemark: "上级页面："+prevPage,
        isEntranceData: this.isEntranceData,
      };
      this.$api.insertPageAccessData(params).then((res) => {});
    },
  },
};
</script>

<style scoped>
.box {
  min-height: 100%;
  background-color: #f3f3f3;
  overflow: hidden;
  /* height:calc(48px + env(safe-area-inset-bottom)); */
  padding-bottom: constant(safe-area-inset-bottom);
  /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom);
  /* 兼容 iOS >= 11.2 */
  /* box-sizing: content-box; */
}
.content {
  width: 100%;
  margin-top: calc(44px + env(safe-area-inset-top));
  box-sizing: border-box;
  position: relative;
  text-align: center;
}
.content>img{
  width: 100%;
  display: block;
}
.content-pos{
  position: absolute;
  left: 50%;
  top: 30px;
  transform: translateX(-50%);
  /* padding:30px 40px; */
  box-sizing: border-box;
}
.line{
  background-image: linear-gradient(-90deg, rgba(255,211,130,0.00) 0%, #FFE0A7 49%, rgba(255,211,130,0.00) 100%);
border-radius: 100px;
height: 1px;
margin: 6px auto;
}
.content-title{
  font-size: 20px;
color: #FFD382;
}
.content-tips{
  font-size: 26px;
color: #FFD382;
line-height: 37px;
}
.content-code{
  width: 221px;
  height: 221px;
  /* background-image: linear-gradient(-180deg, #EFEDEC 0%, #FFFFFF 100%); */
border-radius: 4px;
margin:0 auto;
 margin-top: 20px;
 margin-bottom: 16px;
}
.content-code>img{
  width: 221px;
  height: 221px;
  /* margin-top: 12px; */
}
.text-one{
  font-size: 14px;
color: #D5CDB6;
}
.text-two{
  font-size: 16px;
color: #FFE0A7;
margin:0 auto;
margin-top: 12px;
margin-bottom: 16px;
width: 304px;

}
.text-three{
 background: #221F1B;
border: 1px solid #FFE0A7;
border-radius: 100px;
font-size: 14px;
color: #FFE0A7;
width: 279px;
height: 26px;
margin:0 auto;
line-height: 26px;
}
</style>



// WEBPACK FOOTER //
// src/view/guideCode/index.vue